export const NEW_GROUP = 'New Group';
export const GROUP_NAME = 'Group name ...';
export const ENTER_JOIN_CODE = 'Enter Join Code';
export const ADD_TASK = 'Add Task';
export const EDIT_TASK = 'Edit Task';
export const TITLE = 'Title';
export const DUE = 'Due';
export const DESCRIPTION = 'Description';
export const SUBMISSION = 'Submission';
export const NO_PERMISSION = 'Permession not granted';
export const CONTACT_PERMISSION = 'Please give permission to access contact list in order to share a contact';
export const NO_CONTACT = 'No Contacts Found';
export const CONTACTS = 'Contacts List';
export const SELECTED = num => `${num} selected`;
export const SHARE = 'Share';
export const SEARCH = 'Search';
export const PROFILE = 'Profile';
export const CAMERA = 'Camera';
export const PHOTOS_VIDEOS = ' Photos & Videos';
export const DOCUMENTS = 'Documents';
export const POLL = 'Poll';
export const LOCATION = 'Location';
export const CONTACT = 'Contact';
export const ATTACHMENTS = 'Attachments';
export const ADD_ATTACHMENT = 'add attachment';
export const SEND_LOCATION = 'Send Location';
export const LOCATION_PERMISSION = 'Please give permission to access your location in order to share location';
export const UNBLOCK = 'Unblock';
export const BLOCK_LIST = 'Block List';
export const REASON = 'Reason';
export const OPTIONAL = 'Optional';
export const BLOCK_FROM_GROUP = 'Block From Group';
export const REPORT_MEMBER = 'Report Member';
export const DONE = 'Done';
export const SEXUAL_CONTENT = 'Sexual Content';
export const VIOLENT_CONTENT = 'Violent Content';
export const SPAM = 'Spam';
export const SUBMISSIONS = 'Submissions';
export const MEMBERS_INFO = `Member's Info`;
export const TIME = 'Time';
export const MEDIA = 'Media';



// WEBPACK FOOTER //
// ./src/lang/en/modal.js